export default async function () {
  switch (window.siteInfo.site) {
    case 'zava':
      await import(/* webpackChunkName: "zava-bulma-styles" */'@/shared/styles/zava.scss')
      break
    case 'sd':
      await import(/* webpackChunkName: "sd-bulma-styles" */'@/shared/styles/sd.scss')
      break
    case 'dred':
      await import(/* webpackChunkName: "dred-bulma-styles" */'@/shared/styles/dred.scss')
      break
    case 'tosca':
      await import(/* webpackChunkName: "tosca-bulma-styles" */'@/shared/styles/tosca.scss')
      break
  }
}
